// debounce for toasts and logout_and_redirect
export const DEBOUNCE_DELAY_MS = 1000;
// DO not refresh the token if the request url is in this list
export const NO_REFRESH_ENDPOINTS = ["/auth/login", "/auth/refresh-token"];
// Will not refresh the token if the response status code is in this list
export const NO_REFRESH_STATUS_CODES = [401, 403];
// Setting this to true will show a toast when refreshing the token
export const SHOW_ISREFRESHING_TOAST = true;